import { Link } from 'react-router-dom';

/**
 * Brand logo wordmark. Renders the gradnext logo image with the correct
 * aspect ratio + accessible alt text. Set `to` to wrap it in a router Link.
 *
 * Sizes:
 *   sm  -> ~24px tall (headers)
 *   md  -> ~32px tall (default)
 *   lg  -> ~40px tall (auth pages hero)
 */
export const BrandLogo = ({ size = 'md', to, className = '' }) => {
    const heights = { sm: 'h-6', md: 'h-8', lg: 'h-10' };
    const img = (
        <img
            src="/brand/gradnext-logo.webp"
            alt="gradnext"
            className={`${heights[size] || heights.md} w-auto select-none ${className}`}
            data-testid="brand-logo"
            draggable={false}
        />
    );
    if (to) return <Link to={to} aria-label="gradnext">{img}</Link>;
    return img;
};
